import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=39dc46dc&scoped=true&"
import script from "./OrderCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=39dc46dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc46dc",
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar,QImg,QChip,QIcon});
